import { render, staticRenderFns } from "./CaptchaScene.vue?vue&type=template&id=5c884693&"
import script from "./CaptchaScene.vue?vue&type=script&lang=js&"
export * from "./CaptchaScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports